import { TextAlignButton, useComponentsContext, usePortalElement } from '@blocknote/react';
import { ChevronDownIcon, MoveHorizontalIcon } from 'lucide-react';

type BasicTextAlign = React.ComponentProps<typeof TextAlignButton>['textAlignment'];

export function CustomTextAlignSelect() {
  const Components = useComponentsContext()!;
  const portalElement = usePortalElement();

  const variants = ['left', 'center', 'right', 'justify'] satisfies BasicTextAlign[];

  return (
    <Components.Generic.Menu.Root portalElement={portalElement}>
      <Components.Generic.Menu.Trigger>
        <Components.FormattingToolbar.Button
          className="bn-dropdown-button"
          label="Text align select"
          mainTooltip="Select text align"
        >
          <MoveHorizontalIcon className="icon-lg" />
          <ChevronDownIcon className="icon-sm" />
        </Components.FormattingToolbar.Button>
      </Components.Generic.Menu.Trigger>
      <Components.Generic.Menu.Dropdown>
        <Components.Generic.Menu.Item className="no-hover-bg">
          {variants.map((el) => (
            <TextAlignButton textAlignment={el} key={`textAlign${el.charAt(0).toUpperCase() + el.slice(1)}Button`} />
          ))}
        </Components.Generic.Menu.Item>
      </Components.Generic.Menu.Dropdown>
    </Components.Generic.Menu.Root>
  );
}
